import { computed } from "@ember/object";
import { or } from "@ember/object/computed";
import { attributeBindings, classNames, tagName } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";
import { resolveComponent } from "select-kit/components/select-kit";
import SelectKitHeaderComponent from "select-kit/components/select-kit/select-kit-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SingleSelectHeader = dt7948.c(class SingleSelectHeader extends SelectKitHeaderComponent {
  static {
    dt7948.g(this.prototype, "ariaLabel", [or("selectKit.options.headerAriaLabel", "name")]);
  }
  #ariaLabel = (dt7948.i(this, "ariaLabel"), void 0);
  focusIn(event) {
    event.stopImmediatePropagation();
    document.querySelectorAll(".select-kit-header").forEach(header => {
      if (header !== event.target) {
        header.parentNode.open = false;
      }
    });
  }
  get name() {
    if (this.selectedContent) {
      return i18n("select_kit.filter_by", {
        name: this.getName(this.selectedContent)
      });
    } else {
      return i18n("select_kit.select_to_filter");
    }
  }
  static {
    dt7948.n(this.prototype, "name", [computed("selectedContent.name")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      {{#each this.icons as |iconName|}} {{icon iconName}} {{/each}}\n\n      {{#let (resolveComponent this this.selectKit.options.selectedNameComponent) as |SelectedNameComponent|}}\n        <SelectedNameComponent @item={{this.selectedContent}} @selectKit={{this.selectKit}} />\n      {{/let}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        icon,
        resolveComponent
      })
    }), this);
  }
}, [attributeBindings("name", "ariaLabel:aria-label"), classNames("single-select-header"), tagName("summary")]);
export default SingleSelectHeader;